// 天気アイコン付きカスタムツールチップ（Chart.js external tooltip）
//
// 使い方:
//   import { weatherTooltipPlugin } from "./chart_weather_tooltip"
//   tooltip: weatherTooltipPlugin(weatherArray, labelsArray, formatLabel)

const TOOLTIP_ID = "chartjs-weather-tooltip"

function findTooltipContainer(chart) {
  // 2週間ビューではcanvasがscrollable-wrapper→overflow:autoコンテナ内にあるため、
  // overflow:autoの外側にツールチップを配置する
  let el = chart.canvas.parentNode
  while (el && el.parentNode) {
    const style = window.getComputedStyle(el)
    if (style.overflowX === "auto" || style.overflowX === "scroll" ||
        style.overflowY === "auto" || style.overflowY === "scroll") {
      el = el.parentNode
      continue
    }
    break
  }
  return el
}

function getOrCreateTooltip(chart) {
  const container = findTooltipContainer(chart)
  let el = container.querySelector(`#${TOOLTIP_ID}`)
  if (el) return el

  el = document.createElement("div")
  el.id = TOOLTIP_ID
  Object.assign(el.style, {
    opacity: "0",
    position: "absolute",
    background: "white",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "10px 12px",
    pointerEvents: "none",
    transition: "opacity 0.15s ease",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    zIndex: "10",
    fontSize: "12px",
    color: "#333",
    whiteSpace: "nowrap"
  })
  container.style.position = "relative"
  container.appendChild(el)
  return el
}

/**
 * @param {Array} weather - [{ weather, max, min, icon }, ...]
 * @param {Array} labels  - ["1", "2", ...]
 * @param {function} formatLabel - (context) => string  (例: "1.5 時間")
 */
export function weatherTooltipPlugin(weather, labels, formatLabel) {
  return {
    enabled: false,
    position: "nearest",
    external(context) {
      const { chart, tooltip } = context
      const tooltipEl = getOrCreateTooltip(chart)

      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = "0"
        return
      }

      const dataIndex = tooltip.dataPoints?.[0]?.dataIndex
      if (dataIndex === undefined) return

      const w = weather[dataIndex]
      const day = labels[dataIndex]

      tooltipEl.innerHTML = ""

      // 日付 + 値
      const titleDiv = document.createElement("div")
      titleDiv.style.fontWeight = "bold"
      titleDiv.style.marginBottom = "4px"

      const dayText = `${day}日`
      const valueLines = tooltip.dataPoints.map((dp) => formatLabel(dp))
      titleDiv.textContent = dayText
      tooltipEl.appendChild(titleDiv)

      valueLines.forEach((line) => {
        const valueDiv = document.createElement("div")
        valueDiv.textContent = line
        valueDiv.style.marginBottom = "2px"
        tooltipEl.appendChild(valueDiv)
      })

      // 天気アイコン + 気温
      if (w?.icon) {
        const weatherDiv = document.createElement("div")
        weatherDiv.style.display = "flex"
        weatherDiv.style.alignItems = "center"
        weatherDiv.style.gap = "6px"
        weatherDiv.style.marginTop = "6px"

        const img = document.createElement("img")
        img.src = w.icon
        img.alt = w.weather || ""
        img.style.width = "24px"
        img.style.height = "24px"
        weatherDiv.appendChild(img)

        if (w.max != null) {
          const tempSpan = document.createElement("span")
          tempSpan.textContent = `${w.max}℃ / ${w.min}℃`
          weatherDiv.appendChild(tempSpan)
        }

        tooltipEl.appendChild(weatherDiv)
      }

      // canvasとツールチップ親コンテナの位置差分からtooltip座標を算出
      const container = findTooltipContainer(chart)
      const containerRect = container.getBoundingClientRect()
      const canvasRect = chart.canvas.getBoundingClientRect()
      const offsetX = canvasRect.left - containerRect.left
      const offsetY = canvasRect.top - containerRect.top

      let left = offsetX + tooltip.caretX
      let top = offsetY + tooltip.caretY - tooltipEl.offsetHeight - 8

      // コンテナからはみ出さないようクランプ
      const containerW = container.offsetWidth
      const containerH = container.offsetHeight
      if (top < 0) {
        top = offsetY + tooltip.caretY + 8
      }
      if (top + tooltipEl.offsetHeight > containerH) {
        top = containerH - tooltipEl.offsetHeight
      }
      if (left + tooltipEl.offsetWidth > containerW) {
        left = containerW - tooltipEl.offsetWidth - 4
      }
      if (left < 0) {
        left = 4
      }

      tooltipEl.style.opacity = "1"
      tooltipEl.style.left = `${left}px`
      tooltipEl.style.top = `${top}px`
    }
  }
}
